import { MobileHomeInformationFieldNames } from '@contracts/order/fields/MobileHomeInformationFields';
import {
  BooleanField,
  PositiveFloatField,
  PositiveIntegerField,
  StringField,
} from '@src/permitField/PermitFields';
import type { NumberSchema, StringSchema } from 'yup';
import * as yup from 'yup';

export class LoadIsMobileHomeField extends BooleanField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.LoadIsMobileHome;
}

export class IsUsedMobileHomeField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.IsUsedMobileHome;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.required(),
    });
}

export class MobileHomeYearField extends PositiveIntegerField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeYear;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) =>
        schema.typeError('isNumber').positive().integer().required(),
    });
}

export class MobileHomeMakeField extends StringField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeMake;
  public static validator: StringSchema = yup
    .string()
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class MobileHomeSerialNumberField extends StringField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeSerialNumber;
  public static validator: StringSchema = yup
    .string()
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class MobileHomeHitchLengthField extends PositiveFloatField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeHitchLength;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.typeError('isNumber').positive().required(),
    });
}

export class MobileHomeEaveWidthField extends PositiveFloatField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeEaveWidth;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.typeError('isNumber').positive().required(),
    });
}

export class MobileHomeBoxWidthField extends PositiveFloatField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeBoxWidth;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.typeError('isNumber').positive().required(),
    });
}

export class MobileHomeBoxLengthField extends PositiveFloatField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeBoxLength;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.typeError('isNumber').positive().required(),
    });
}

export class MobileHomeRoadsideEavesLengthField extends PositiveFloatField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeRoadsideEavesLength;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.typeError('isNumber').positive().required(),
    });
}

export class MobileHomeCurbsideEavesLengthField extends PositiveFloatField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeCurbsideEavesLength;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.typeError('isNumber').positive().required(),
    });
}

export class MobileHomeHudNumberField extends StringField {
  public static fieldName: string =
    MobileHomeInformationFieldNames.MobileHomeHudNumber;
  public static validator: StringSchema = yup
    .string()
    .when(LoadIsMobileHomeField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export const mobileHomeFields = {
  [LoadIsMobileHomeField.fieldName]: LoadIsMobileHomeField.validator,
  [IsUsedMobileHomeField.fieldName]: IsUsedMobileHomeField.validator,
  [MobileHomeYearField.fieldName]: MobileHomeYearField.validator,
  [MobileHomeMakeField.fieldName]: MobileHomeMakeField.validator,
  [MobileHomeSerialNumberField.fieldName]:
    MobileHomeSerialNumberField.validator,
  [MobileHomeHitchLengthField.fieldName]: MobileHomeHitchLengthField.validator,
  [MobileHomeEaveWidthField.fieldName]: MobileHomeEaveWidthField.validator,
  [MobileHomeBoxWidthField.fieldName]: MobileHomeBoxWidthField.validator,
  [MobileHomeBoxLengthField.fieldName]: MobileHomeBoxLengthField.validator,
  [MobileHomeRoadsideEavesLengthField.fieldName]:
    MobileHomeRoadsideEavesLengthField.validator,
  [MobileHomeCurbsideEavesLengthField.fieldName]:
    MobileHomeCurbsideEavesLengthField.validator,
  [MobileHomeHudNumberField.fieldName]: MobileHomeHudNumberField.validator,
};
